export default "__VITE_ASSET__CEWIfgMW__"